import React from "react";
import styles from "./Button.module.scss";
import { Tooltip } from "react-tooltip";

interface ButtonProps {
  text: React.ReactNode | string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  variant?: "primary" | "secondary" | "danger" | "tertiary" | "success";
  loading?: boolean;
  isIcon?: boolean;
  disabledTooltip?: string;
}

const Button: React.FC<ButtonProps> = ({
  text,
  onClick,
  type = "button",
  disabled = false,
  loading = false,
  variant = "primary",
  isIcon = false,
  disabledTooltip,
}) => {
  const buttonClasses = `${styles.button} ${styles[variant]} ${disabled ? styles.disabled : ""} ${isIcon ? styles.icon : ""}`;
  const tooltipId = disabledTooltip ? `button-tooltip-${Math.random().toString(36).substr(2, 9)}` : undefined;
  const isDisabled = disabled || loading;

  // If we have a disabled tooltip, wrap in a span to handle the tooltip events
  // since disabled buttons can't trigger hover events due to pointer-events: none
  if (isDisabled && disabledTooltip) {
    return (
      <span 
        className={styles.buttonWrapper}
        data-tooltip-id={tooltipId}
        data-tooltip-content={disabledTooltip}
      >
        <button
          className={buttonClasses}
          onClick={onClick}
          type={type}
          disabled={isDisabled}
        >
          {loading ? "Loading..." : text}
        </button>
        <Tooltip id={tooltipId} place="top" variant="dark" float />
      </span>
    );
  }

  // Regular button without tooltip
  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      type={type}
      disabled={isDisabled}
    >
      {loading ? "Loading..." : text}
    </button>
  );
};

export default Button;
